export const snack=[
    {
      "quantity":1,
      "id":46,
    "name":"Chicken & Fries Bucket",
    "detail":"Crowd-favorite combo of 2pc Hot & Crispy chicken with Medium Fries",
    "price":299.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00000789.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":47,
    "name":"Popcorn & Fries bucket",
    "detail":"Large Chicken Popcorn with Med Fries - at a deal price",
    "price":319.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00000792.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":48,
    "name":"Mingles Bucket",
    "detail":"Save 13% on this mingle of 4 Wings, 2 Strips & a Reg Popcorn",
    "price":339.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002171.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":49,
    "name":"4pc Hot & Crispy Chicken",
    "detail":"4 pcs of signature Hot & crispy chicken at a deal price",
    "price":428.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K008.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":50,
    "name":"Large Popcorn",
    "detail":"Signature bite-sized boneless chicken, with special spices",
    "price":228.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K223.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":51,
    "name":"Medium Popcorn",
    "detail":"Signature bite-sized boneless chicken, with special spices",
    "price":164.76,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K137.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":52,
    "name":"Regular Popcorn",
    "detail":"Signature bite-sized boneless chicken, with special spices",
    "price":115.24,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K136.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":53,
    "name":"Large Fries",
    "detail":"Jazz up your meal with crispy large fries!",
    "price":119.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K138.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":54,
    "name":"2 pcs Smoky Red Chicken",
    "detail":"Spicy, red, grilled chicken",
    "price":248.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K444.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":55,
    "name":"Medium Fries",
    "detail":"Jazz up your meal with Crispy Fries!",
    "price":99.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K016.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":56,
    "name":"2 pc Hot & Crispy Chicken",
    "detail":"Signature Hot & crispy chicken",
    "price":229.52,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K007.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":57,
    "name":"1 pc Smoky Red Chicken",
    "detail":"Spicy, red, grilled chicken",
    "price":124.76,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K443.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":58,
    "name":"4pc Hot Chicken Wings",
    "detail":"Seasoned, signature KFC chicken wings",
    "price":164.76,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K303.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":59,
    "name":"Peri Peri 3pc Chicken Strips",
    "detail":"3 Spicy Peri Peri chicken strips",
    "price":175.24,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002159.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":60,
    "name":"2 pc Veg Patty",
    "detail":"Delicious, crispy, veg add-on",
    "price":155.24,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K351.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":61,
    "name":"Tandoori Masala Dip",
    "detail":"Special tandoori flavor dip to add a twist to your meal",
    "price":28.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K616.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":62,
    "name":"Pack of 4 Dips",
    "detail":"Adding dips is always a good idea!",
    "price":109.52,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00000852.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":63,
    "name":"Nashville Hot Pepper Dip",
    "detail":"Hot, peppery goodness of Nashville - our new signature dip",
    "price":28.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K662.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":64,
    "name":"Pack of 2 Dips",
    "detail":"Adding dips is always a good idea!",
    "price":57.14,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00000853.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":65,
    "name":"Dynamite Spicy Mayo Dip",
    "detail":"Spicy, punchy mayo -our new signature dip",
    "price":28.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K661.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":66,
    "name":"Buttered Bun",
    "detail":"Buttered, soft bun - pairs well with all things KFC",
    "price":35.23,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K678.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":67,
    "name":"Biryani Rice",
    "detail":"Flavorful aromatic rice to pair with your KFC favorites",
    "price":139.04,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K677.jpg?ver=20.85"
    }
    ];